// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/inventory/v1/inventory_alerts.proto" (package "c1.api.inventory.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InventoryAlertSearch } from "./inventory_alerts";
import type { SearchHistoricalInventoryAlertsResponse } from "./inventory_alerts";
import type { SearchHistoricalInventoryAlertsRequest } from "./inventory_alerts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SearchInventoryAlertsResponse } from "./inventory_alerts";
import type { SearchInventoryAlertsRequest } from "./inventory_alerts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.inventory.v1.InventoryAlertSearch
 */
export interface IInventoryAlertSearchClient {
    /**
     * @generated from protobuf rpc: SearchInventoryAlerts
     */
    searchInventoryAlerts(input: SearchInventoryAlertsRequest, options?: RpcOptions): UnaryCall<SearchInventoryAlertsRequest, SearchInventoryAlertsResponse>;
    /**
     * @generated from protobuf rpc: SearchHistoricalInventoryAlerts
     */
    searchHistoricalInventoryAlerts(input: SearchHistoricalInventoryAlertsRequest, options?: RpcOptions): UnaryCall<SearchHistoricalInventoryAlertsRequest, SearchHistoricalInventoryAlertsResponse>;
}
/**
 * @generated from protobuf service c1.api.inventory.v1.InventoryAlertSearch
 */
export class InventoryAlertSearchClient implements IInventoryAlertSearchClient, ServiceInfo {
    typeName = InventoryAlertSearch.typeName;
    methods = InventoryAlertSearch.methods;
    options = InventoryAlertSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SearchInventoryAlerts
     */
    searchInventoryAlerts(input: SearchInventoryAlertsRequest, options?: RpcOptions): UnaryCall<SearchInventoryAlertsRequest, SearchInventoryAlertsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchInventoryAlertsRequest, SearchInventoryAlertsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchHistoricalInventoryAlerts
     */
    searchHistoricalInventoryAlerts(input: SearchHistoricalInventoryAlertsRequest, options?: RpcOptions): UnaryCall<SearchHistoricalInventoryAlertsRequest, SearchHistoricalInventoryAlertsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchHistoricalInventoryAlertsRequest, SearchHistoricalInventoryAlertsResponse>("unary", this._transport, method, opt, input);
    }
}
